import {useCallback} from 'react';
// eslint-disable-next-line monorepo/no-internal-import
import {useWishlistMinimalState} from './useWishlistState';

export const useWishlistCount = () => {
  const {data, isLoading} = useWishlistMinimalState();
  const count = data?.wishlistState ? data?.wishlistState.items.length : 0;

  return {count, isLoading};
};

export const useIsProductInWishlist = (productId?: number) => {
  const products = useWishlistProductIds();
  if (productId) {
    return products.includes(productId);
  }

  return false;
};

export const useGetProductIsInWishlist = () => {
  const wishlistProductIds = useWishlistProductIds();
  return useCallback(
    ({productId: productIdToCompare}: {productId: number}) => {
      return wishlistProductIds.includes(productIdToCompare);
    },
    [wishlistProductIds],
  );
};

export const useIsWishlistLoaded = () => {
  const {data, isLoading} = useWishlistMinimalState();
  return data && !isLoading;
};

export const useWishlistTokenHash = () => {
  const {data} = useWishlistMinimalState();

  if (data?.wishlistState.token) {
    // if its used as refetch token then it needs to be a string
    return data.wishlistState.token.hash.toString();
  }

  return null;
};

export const useWishlistProductIds = () => {
  const {data} = useWishlistMinimalState();
  return data?.wishlistState.items.map(item => item.productId) ?? [];
};

export const useWishlistBubbleColour = () => {
  const {data} = useWishlistMinimalState();
  return data?.bubbleColor;
};

export const useWishlistProducts = () => {
  const {data} = useWishlistMinimalState();
  return data?.wishlistState.items || [];
};

export const useClearWishlistBubble = () => {
  const {data, updateCache} = useWishlistMinimalState();

  return useCallback(() => {
    if (data) {
      updateCache({...data, bubbleColor: undefined});
    }
  }, [data, updateCache]);
};
